// Corsac floating contact widget behavior. Edit this file directly in
// Shopify's asset editor to change how the widget behaves -- no corsac
// deploy needed. Expects the widget's HTML markup to already exist in
// the DOM (pasted into theme.liquid, see docs/floating-widget-
// integration.md in the corsac repo) -- this file only wires up
// behavior, it doesn't build any elements. The only network call this
// makes is the actual form submission, to corsac's /api/contact.
(function () {
  if (window.__corsacWidgetInit) return; // guards against an accidental double-paste of the <script> tag
  window.__corsacWidgetInit = true;

  var ENDPOINT = 'https://corsac.onrender.com/api/contact';
  var SUPPORT_EMAIL = 'support@pluginfox.com';
  var FIXED_SUBJECT = 'Website contact widget';

  function init() {
    var toggle = document.getElementById('corsac-widget-toggle');
    var panel = document.getElementById('corsac-widget-panel');
    var closeBtn = document.getElementById('corsac-widget-close');
    var form = document.getElementById('corsac-widget-form');
    var submitBtn = document.getElementById('corsac-widget-submit');
    var msgEl = document.getElementById('corsac-widget-msg');
    if (!toggle || !panel || !form) return; // the theme.liquid HTML block wasn't pasted -- nothing to wire up

    function openPanel() {
      panel.classList.add('corsac-open');
      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      var first = form.querySelector('input[name="name"]');
      if (first) first.focus();
    }
    function closePanel() {
      panel.classList.remove('corsac-open');
      panel.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      // Reset back to a fresh form on close, so a later reopen after a
      // successful send doesn't just show the old confirmation message.
      if (form.hidden) {
        form.hidden = false;
        setMessage('', null);
      }
    }
    toggle.addEventListener('click', function () {
      if (panel.classList.contains('corsac-open')) closePanel(); else openPanel();
    });
    closeBtn.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('corsac-open')) closePanel();
    });

    function setMessage(content, type) {
      msgEl.textContent = '';
      msgEl.className = type ? 'corsac-' + type : '';
      if (!content) return;
      if (typeof content === 'string') {
        msgEl.textContent = content;
      } else {
        msgEl.appendChild(content);
      }
    }

    function mailtoFallback() {
      var wrap = document.createElement('span');
      wrap.appendChild(document.createTextNode('Something went wrong. Please email us directly at '));
      var link = document.createElement('a');
      link.href = 'mailto:' + SUPPORT_EMAIL;
      link.textContent = SUPPORT_EMAIL;
      wrap.appendChild(link);
      wrap.appendChild(document.createTextNode(' instead.'));
      return wrap;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      // Rapid-click guard: ignore a second submit while the first request
      // is still in flight -- same pattern as page-contact.liquid's own
      // corsacSubmitting flag (docs/contact-form-integration.md).
      if (form.dataset.submitting === 'true') return;
      form.dataset.submitting = 'true';
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
      setMessage('', null);

      var data = new FormData(form);
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: data.get('name') || '',
          email: data.get('email') || '',
          subject: FIXED_SUBJECT,
          message: data.get('message') || '',
          website: data.get('website') || '',
          order: data.get('order') || '',
        }),
      })
        .then(function (res) {
          if (res.ok) return res.json().then(function () { return { success: true }; });
          if (res.status >= 400 && res.status < 500) {
            // corsac actively rejected this input (bad email, empty
            // message) -- real, actionable feedback.
            return res.json().then(function (data) { return { success: false, message: data.error }; });
          }
          return Promise.reject(); // 5xx/network -- real failure
        })
        .then(function (result) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send';
          if (result.success) {
            form.reset();
            form.hidden = true;
            setMessage('Thanks -- we got your message and will get back to you by email soon.', 'success');
          } else {
            form.dataset.submitting = 'false';
            setMessage(result.message || 'Please check your details and try again.', 'error');
          }
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send';
          form.dataset.submitting = 'false';
          setMessage(mailtoFallback(), 'error');
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();